module.exports = __webpack_public_path__ + "static/img/yiti_08.f702582f.jpg";